export default {
	right: 'right eye',
	left: 'left eye',
	both: 'both eyes',
	'none of the above': 'none of the above'
};



// WEBPACK FOOTER //
// ./src/data/eyeMap.js